export const Constants = {
  TAG_NAME: 'pop-characteristics-table-component',
  CLASS_AS_OF_DATE: 'as-of-date',
  CLASS_BENCHMARK: 'benchmark-label',
  CLASS_CHARACTERISTICS_TABLE: 'characteristics-table',
  CLASS_CONTAINER_ALL: 'b-container',
  CLASS_TITLE: 'characteristics-title',
  COMPONENT_TITLE: 'Characteristics',
  COMPONENT_UNAVAILABLE: 'Characteristics unavailable',
  AS_OF_DATE_PREFIX: 'Data as of',
  BENCHMARK_NAME_LABEL: 'Benchmark:',
  DATA_TITLE: 'data-title',
  BENCHMARK_COLUMN_LABEL: 'Benchmark',
  NO_DATA_MESSAGE: 'No data available',
  NOT_APPLICABLE: 'N/A',
} as const;
